<template>
  <main>


  <!-- Icono de hamburguesa -->
    <div class="hamburger-icon" @click="toggleMenu">
      <!-- Font Awesome icono de hamburguesa -->
      <i class="fas fa-bars" style="font-size: 24px;"></i>
    </div>

    <!-- Resto de tu contenido -->

    <!-- Menú desplegable -->
    <div
      class="menu"
      :class="{ 'menu-open': isMenuOpen }"
      @mouseout="startMenuCloseTimer"
      @mouseover="cancelMenuClose"
    >
      <ul>
        <!-- Agrega aquí tus elementos de menú -->
        
        <li><router-link to="/changue_pass" @click="closeMenu">Cambiar Contraseña</router-link></li>
        <li><router-link to="/" @click="closeMenu">Cerrar Sesión</router-link></li>
        <!-- ... y así sucesivamente -->
      </ul>
    </div>


    <div class="sentence">
      <img src="./../assets/logo/Grupo 92.svg" width="35%" alt="osfatun" />
    </div>

    <section class="content ">
      <h3 class="title mb-5 has-text-centered">
        ¡Hola {{ this.$store.state.name }}!
      </h3>
      
     
      <b-loading
        :is-full-page="isFullPage"
        v-model="loading"
        :can-cancel="true"
      >
        <b-icon
          pack="fas"
          icon="sync-alt"
          size="is-large"
          custom-class="fa-spin"
        >
        </b-icon>
      </b-loading>

      <div v-if="cargado === false">
        <div class="title-h5">
        <h5 class="title mb-5 has-text-centered">
          A continuación cargue la factura que desee presentar. Puede sacarle
          una foto con su dispositivo o cargar archivo PDF y de imagen
          (.jpg y .png).
        </h5>
        <p>* Recuerde que la factura debe estar a nombre de OSFATUN.</p>
        <p>** No se aceptarán facturas tipo “B”.</p>
      </div>
        <div class="centered-upload">
          <b-field
            class="file is-info"
            ref="fileInput"
            :class="{ 'has-name': !!file }"
          >
            <b-upload v-model="file" class="file-label">
              <div class="file-upload">
                <img src="../assets/add-files 1.png" alt="" />
                <p>
                  Haga click para sacarle una foto o abrir la librería de su
                  dispositivo
                </p>
              </div>

              
            </b-upload>
          </b-field>
          
        </div>

        <br /><span class="file-name" v-if="file"> <img
          src="../assets/grupo24.png"
          alt=""
          style="height:20px; width: 15.4px;"
        />
                {{ file.name }}
              </span><br />
        <b-button
          v-if="file != null"
          class="button-charge"
          type="is-info"
          @click="cargarFactura"
          :disabled="loading"
          ><img src="../assets/circle-plus 1.png" alt="" />
          Cargar Factura
        </b-button>

       
      </div>
      <br />
      <div v-if="cargado === true" class="button-next">
        <img
          src="../assets/logo/grupo24.svg"
          alt=""
          style="height:72px; width: 63.4px;"
        />
        <h3 class="cont-h3 p-3">
          Factura Cargada Correctamente
        </h3>
        <br /><br /><br /><br />
        <router-link to="/new_affiliate">
          <b-button
            class="button-charge"
            type="is-success"
            :disabled="loading"
          >
            
            <img src="../assets/next.png" alt="" />Siguiente
          </b-button>
        </router-link>
      </div>
    </section>
    <Footer>
      <p class="m-2">Desarrollado por</p>
      <img src="../assets/logo/logozaro1.svg" alt="zaro" />
    </Footer>
  </main>
</template>

<script>
import axios from "axios";
import { mapMutations } from "vuex";
import { alertSuccess } from "@/helpers";
export default {
  data() {
    return {
      file: null,
      isFullPage: true,
      cargado: false,
      loading: false,
      baseUrl: "https://api.osfatun.com.ar/",
       isMenuOpen: false,
      menuHovered: false,
      menuCloseTimer: null
    };
  },
  // ...
  methods: {

    toggleMenu() {
      this.isMenuOpen = !this.isMenuOpen;
    },
    startMenuCloseTimer() {
      this.menuCloseTimer = setTimeout(() => {
        this.isMenuOpen = false;
      }, 500); // Tiempo en milisegundos antes de cerrar el menú
    },
    cancelMenuClose() {
      clearTimeout(this.menuCloseTimer);
    },
    closeMenu() {
      this.isMenuOpen = false;
    },

    async cargarFactura() {
      try {
        this.loading = true;

        const formData = new FormData();
        formData.append("invoice", this.file);

        const token = this.$store.state.token;

        // Agregar el encabezado de autorización a la solicitud
        const config = {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`, // Agregar el token en el encabezado
          },
        };
        // console.log(formData)
        // Realizar una solicitud POST a la ruta del endpoint con el archivo adjunto y el encabezado de autorización
        const response = await axios.post(
          this.baseUrl + "api/v1/prestador/newInvoice",
          formData,
          config // Pasar el objeto de configuración con el encabezado de autorización
        );

        // En la respuesta, recibirás el ID de la factura creada si todo fue exitoso
        const { invoice_id } = response.data;
       // console.log(invoice_id);
        this.cargado = true;
        alertSuccess("Carga Exitosa!");

        this.setIdInvoice(invoice_id);
        this.loading = false;
      } catch (error) {
        console.error(error);
        this.loading = false;
      }
    },



    
    ...mapMutations(["setToken", "setName", "setIdInvoice"]),
  },
};
</script>

<style>

/* Estilos para el icono de hamburguesa y el menú desplegable */
.hamburger-icon {
  position: fixed;
  top: 20px;
  right: 20px;
  cursor: pointer;
   background-color: #fff; 
   padding: 5px;
   padding-bottom: 2px;
   color: #017c9b;
  border-radius: 5%; 
}

.menu {
  position: fixed;
  top: 0;
  right: 0;
  height: 100%;
  width: 200px;
  background-color: #fff; /* Color de fondo del menú */
  transform: translateX(200px);
  transition: transform 0.3s ease-in-out;
}

.menu ul {
  list-style: none;
  padding: 20px;
}

.menu ul li {
  margin-bottom: 15px;
}

.menu ul li a {
  text-decoration: none;
  color: #000; /* Color del texto del menú por defecto */
}

.menu ul li a:hover {
  color: #017c9b;; /* Color del texto cuando el enlace está en hover */
}


.menu-open {
  transform: translateX(0);
}


.login-card {
  max-width: 400px; /* Ajusta el ancho del b-card */
}
</style>
<style scoped>
.sentence {
  background-image: url("./../assets/fondo.png");
  background-size: 100%;
  width: 100%;
  background-repeat: no-repeat;
  max-height: 33vh;
  padding: 2em;
}
.sentence img {
  padding: 1em;
  width: 220px;
  margin: 0 auto;
  text-align: center;
  display: block; 
}
.content {
  position: relative;
  max-width: 40%;
  padding: 40px 30px;
  margin: 0 auto;
}
h3.title {
  font-weight: bold;
  font-size: 34px;
  color: #00758f;
  line-height: 1.9rem;
  margin: 0 50px;
}
.second-container {
  max-width: 90%;
  margin: 0 auto;
}
.hr {
  background-color: #eeeeee;
  margin: 50px 0;
}
h5.title {
  font-weight: 500;
  font-size: 22px;
  color: rgba(0, 0, 0, 1);
  margin-bottom: 6%;
}

.centered-upload {
  display: flex;
  justify-content: center;
  align-items: center;
  /* Ajusta esta altura según tus necesidades */
  border: 1px dashed #d9d9d9;
  margin-top: 2em;
  padding: 2em;
  font-weight: 100;
  font-size: 14px;
}

.cont-h3 {
  background-color: rgba(0, 143, 40, 1);
  color: white;
  font-size: 15px;
  margin: 0 10em;
}
.button-charge{
  vertical-align: middle; /* Alinear verticalmente la imagen con el texto */
    margin-right: 10px; 
    padding: 10px 20px;
}
.button-charge img{
  vertical-align: middle; /* Alinear verticalmente la imagen con el texto */
    margin-right: 10px; 
}
.button-next {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 1em;
}
.button-next h3{
  display: flex; /* Usamos flexbox para alinear elementos internos */
  justify-content: center;
  padding-top: 1px;
}

footer {
  margin-top: 15em ;
  display: flex;
  justify-content: center;
 
}



/* @media screen and (max-width: 62em) {
  .sentence {
    max-height: 25vh;
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
  }
  .sentence img {
    position: absolute;
    position: relative;
    max-width: 100%;
    max-height: 100%;
    transform: translate(-50%, -50%);
    top: 45%;
    left: 18%;
    display: block;
  }

  .content {
    position: relative;
    background: white;
    max-width: 65%;
    padding: 40px 20px;
    margin: 1em auto;
  }
  .prestadoresForm {
    max-width: 80%;
  }
  h3.title {
    font-size: 29px;
    margin: 0;
  }
  footer {
    margin-top: 7em;
    margin-bottom: 0;
  }
} */

@media screen and (max-width: 42em) {
  .sentence {
    max-height: 15vh;
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    padding: 3em;
  }
  .sentence img {
    width: 35%;
    position: relative;
    max-width: 100%;
    max-height: 100%;
    transform: translate(-50%, -50%);
    top: 40%;
    left: 15%;
    display: block;
    padding-bottom: 0;
  }

  .content {
    position: relative;
    background: white;
    max-width: 95%;
    padding: 40px 20px;
    margin: 1em auto;
  }
  
  h3.title {
    font-size: 29px;
    margin: 0;
  }
  h5.title{
    font-size: 15px;
  }
  .cont-h3 {
    margin: 0 2em;
  }
  footer {
    margin-top: 12em auto;
  }
}
</style>
